import request from '../utils/request'

// 获取邮箱验证码
export function postEmailCode(data) {
  return request({
    url: 'api/home/email/code',
    method: 'post',
    data: data
  })
}

// 登录
export function postLogin(data) {
  return request({
    url: 'api/home/user/login',
    method: 'post',
    data: data
  })
}

// 退出登录
export function postLogout(data) {
  return request({
    url: 'api/home/user/logout',
    method: 'post',
    data: data
  })
}

// 个人信息
export function postUserInfo(data) {
  return request({
    url: 'api/home/user/info',
    method: 'post',
    data: data
  })
}

// 常用配置接口
export function postHomeConfig(data) {
  return request({
    url: 'api/home/config',
    method: 'post',
    data: data
  })
}

// 活动列表
export function postActivityList(data) {
  return request({
    url: 'api/home/activity/lists',
    method: 'post',
    data: data
  })
}

// 参与活动
export function postActivityJoin(data) {
  return request({
    url: 'api/home/activity/join',
    method: 'post',
    data: data
  })
}

// 参与活动排行
export function postActivityRank(data) {
  return request({
    url: 'api/home/activity/rank',
    method: 'post',
    data: data
  })
}

// 当前进行中活动接口
export function postActivityInprocess(data) {
  return request({
    url: 'api/home/activity/in_process',
    method: 'post',
    data: data
  })
}

// 活动参与日志列表
export function postActivityMyjoins(data) {
  return request({
    url: 'api/home/activity/my_joins',
    method: 'post',
    data: data
  })
}
// 9.26
// 网红NFT列表
export function postBabenfts(data) {
  return request({
    url: 'api/home/nft/babe_nfts',
    method: 'post',
    data: data
  })
}

// 热门NFT列表
export function postHotfts(data) {
  return request({
    url: 'api/home/nft/hot_nfts',
    method: 'post',
    data: data
  })
}

// 个人中心活动列表（TOKEN）
export function postActivityMine(data) {
  return request({
    url: 'api/home/activity/mine',
    method: 'post',
    data: data
  })
}

// 推广中心-活动列表（TOKEN）
export function postActivityMyPromotions(data) {
  return request({
    url: 'api/home/activity/my_promotions',
    method: 'post',
    data: data
  })
}

// 活动详情
export function postActivityInfo(data) {
  return request({
    url: 'api/home/activity/info',
    method: 'post',
    data: data
  })
}

// 中奖列表
export function postActivityWinlists(data) {
  return request({
    url: 'api/home/activity/win_lists',
    method: 'post',
    data: data
  })
}

// 9.27

// NFT详情
export function postNftInfo(data) {
  return request({
    url: 'api/home/nft/info',
    method: 'post',
    data: data
  })
}

// 9.30
// 推广中心-NFT列表（TOKEN）
export function postNftMyPromotions(data) {
  return request({
    url: 'api/home/nft/my_promotions',
    method: 'post',
    data: data
  })
}

// 推荐奖励列表
export function postUserReferral(data) {
  return request({
    url: 'api/home/user/referral',
    method: 'post',
    data: data
  })
}

// 购买NFT
export function postNftBuy(data) {
  return request({
    url: 'api/home/nft/buy',
    method: 'post',
    data: data
  })
}

// 个人中心-我拥有的NFT列表
export function postNftMyNfts(data) {
  return request({
    url: 'api/home/nft/my_nfts',
    method: 'post',
    data: data
  })
}

// 10.2
// 活动国家队配置
export function postActivityCountries(data) {
  return request({
    url: 'api/home/activity/countries',
    method: 'post',
    data: data
  })
}

// 10.4
// 兑换码充值
export function postCdkeyExchange(data) {
  return request({
    url: 'api/home/cdkey/exchange',
    method: 'post',
    data: data
  })
}

// 10.15
// 活动页面
export function postGames(data) {
  return request({
    url: 'api/home/games',
    method: 'post',
    data: data
  })
}

// 10.16
// 新闻列表
export function postNews(data) {
  return request({
    url: 'api/home/news',
    method: 'post',
    data: data
  })
}

// 铸造是否免费
export function postMintFree(data) {
  return request({
    url: 'api/home/nft/mint_free',
    method: 'post',
    data: data
  })
}

// 获取充值钱包
export function postUsdtAddress(data) {
  return request({
    url: 'api/home/usdt/address',
    method: 'post',
    data: data
  })
}

// 主动查询充值状态
export function postUsdtQuery(data) {
  return request({
    url: 'api/home/usdt/query',
    method: 'post',
    data: data
  })
}

// 10.22
// Web5 Token提现
export function postWeb5tokenWithdraw(data) {
  return request({
    url: 'api/home/web5token/withdraw',
    method: 'post',
    data: data
  })
}

// Kraze Token提现
export function postKrazetokenWithdraw(data) {
  return request({
    url: 'api/home/kraze_token/withdraw',
    method: 'post',
    data: data
  })
}

// INCOME
export function postUserIncome(data) {
  return request({
    url: 'api/home/user/income',
    method: 'post',
    data: data
  })
}

// 出入金日志
export function postTransferLog(data) {
  return request({
    url: 'api/home/user/transfer_log',
    method: 'post',
    data: data
  })
}

export function postPayRamppage(data) {
  return request({
    url: 'api/home/pay/ramppage',
    method: 'post',
    data: data
  })
}

// 10.29
// 获取题目
export function postQuestionGet() {
  return request({
    url: 'api/home/question/get',
    method: 'post'
  })
}

// 回答问题
export function postQuestionSubmit(data) {
  return request({
    url: 'api/home/question/submit',
    method: 'post',
    data: data
  })
}

// 地址列表
export function postAddressList(data) {
  return request({
    url: 'api/home/address/lists',
    method: 'post',
    data: data
  })
}

// 添加地址
export function postAddressAdd(data) {
  return request({
    url: 'api/home/address/add',
    method: 'post',
    data: data
  })
}

// 地址信息
export function postAddressInfo(data) {
  return request({
    url: 'api/home/address/info',
    method: 'post',
    data: data
  })
}

// 更新地址
export function postAddressUpdate(data) {
  return request({
    url: 'api/home/address/update',
    method: 'post',
    data: data
  })
}

// 删除地址
export function postAddressDelete(data) {
  return request({
    url: 'api/home/address/delete',
    method: 'post',
    data: data
  })
}

// 11.7
// 购买列表
export function postShoppingLists(data) {
  return request({
    url: 'api/home/nft/shopping_lists',
    method: 'post',
    data: data
  })
}

// 购买详情
export function postShoppingDetail(data) {
  return request({
    url: 'api/home/nft/shopping_detail',
    method: 'post',
    data: data
  })
}

// 时空奖励列表
export function postMySpaceRewards(data) {
  return request({
    url: 'api/home/nft/my_space_rewards',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js